import React from 'react';
import IntroSection from '../components/IntroSection';
import ScopingSolution from '../components/ScopingSolution';
import BlueSectionDivider from '../components/BlueSectionDivider';
import SoftwareProcess from '../components/SoftwareProcess';
import CustomerTestimonials from '../components/CustomerTestimonials';
import WebflowSection from '../components/WebflowSection';
import WebflowSupport from '../components/WebflowSupport';
import WebBenefits from '../components/WebBenefits';
import WebAwards from '../components/WebAwards';
import CountriesSection from '../components/CountriesSection';
import WebReimagine from '../components/WebReimagine';
import WebProjects from '../components/WebProjects';
import TeamSection from '../components/TeamSection';
import WhyUsSection from '../components/WhyUsSection';
import WorkingModelSection from '../components/WorkingModelSection';
import TechStackSection from '../components/TechStackSection';
import WebResources from '../components/WebResources';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import WebFaq from '../components/WebFaq';


const WebDevelopment = ()=>{
    return (
        <div>
            <IntroSection title = "WEB DEVELOPMENT" paragraph = "Scalable, robust, user-centric, and enterprise-grade web development solutions." backgroundImage="/images/wd-bg.webp"/>
            <ScopingSolution para1 = "Our expertise ranges from simple website development to complex web-based applications, helping clients strategically invest in digital capabilities to enhance their competitive advantage" para2 = "We provide the right tools and resources to guide you through the process of developing robust web-based solutions. Whether you are an enterprise scaling your online presence or enhancing your digital product capabilities, our expert team ensures that every step is aligned with your strategic goals."/>
            <BlueSectionDivider/>
            <SoftwareProcess/>
            
            <WebflowSection/>
            <WebflowSupport/>
            <WebBenefits/>
           
            <CountriesSection/>
            <WebReimagine/>
            <BlueSectionDivider/>
            <WebProjects/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <WebFaq/>
            
             <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>
            

        </div>
)}
export default WebDevelopment;